import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionType from 'utils/mw/actionType.util';
import asObject from 'utils/objects/asObject.util';

const ATAG = 'beSaveTimeOffCategory';
const AT = actionType(ATAG);

const beSaveTimeOffCategory = (options) => {
  const o = asObject(options);

  return o.isNew
    ? endpoint(H.post, 'salon/v2/:salonId/time_off_categories/', {
        AT,
        name: ATAG,
        params: { salonId: o.salonId, isNew: true, id: o.category.id },
        data: { ...asObject(o.category) },
      })
    : endpoint(H.put, `salon/v2/:salonId/time_off_categories/:id/`, {
        AT,
        name: ATAG,
        params: { salonId: o.salonId, id: o.category.id },
        data: { ...asObject(o.category) },
      });
};

beSaveTimeOffCategory.AT = AT;
beSaveTimeOffCategory.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beSaveTimeOffCategory;
